module.exports = __webpack_public_path__ + "images/S1.png";